import './PlayerCard.scss'

import Menu, { MenuItem } from '../../Menu/Menu'

import Avatar from '../../Avatar/Avatar'
import Button from '../../../components/Button/Button'
import Checkbox from '../../Checkbox/Checkbox'
import Dropdown from '../../Dropdown/Dropdown'
import Icon from '../../../components/Icon/Icon'
import PropTypes from 'prop-types'
import React from 'react'
import t from '../../../helpers/i18n'

const PlayerCard = ({
  firstName,
  lastName,
  avatar,
  birthDate,
  onClick,
  onRemove
}) => {
  return (
    <div className='player-card-module'>
      <div className='-header'>
        <div className='-controls'>
          <div className='-menu'>
            <Checkbox />
            <div className="-divider" />
            <Dropdown button={<Icon size={16} icon='MoreIcon' />} basic>
              <Menu size="medium">
                <MenuItem title={t('technical.Remove from team')} icon="DeleteIcon" onClick={onRemove} />
              </Menu>
            </Dropdown>
          </div>
          <div className='-first-name proper-noun-field-sized-basic'>{firstName}</div>
          <div className='-last-name proper-noun-large-semibold'>{lastName}</div>
        </div>
        <div className='-avatar'>
          <Avatar size="large" source={avatar} />
        </div>
      </div>

      <div className='-description'>
        <div className='-row'>
          <div className='-label label-small-basic'>{t('labels.Date_of_birth')}</div>
          <div className='-data proper-noun-small-medium'>{birthDate}</div>
        </div>
      </div>

      <div className='-main-button'>
        <Button
          size='field-sized'
          type='light'
          color='green'
          label={t('buttons.Open_full_profile')}
          icon='ArrowRightIcon'
          iconPosition='trailing'
          grow
          onClick={onClick}
        />
      </div>
    </div>
  )
}

PlayerCard.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  avatar: PropTypes.string,
  birthDate: PropTypes.string,
  onClick: PropTypes.func
}

PlayerCard.defaultProps = {}

export default PlayerCard